import React from 'react';
import '../App.css';

const Terms = () => {
  return (
    <div className="" style={{ display: 'flex', alignItems: '', justifyContent: 'center', height: '100vh', overflow: 'auto', width: '100vw', background: '#a1a1a1', padding: '20px', marginBottom: '100px' }}>
      <div style={{ width: '100%', maxWidth: '800px', background: '#a1a1a1', padding: '20px', display: 'flex', flexDirection: 'column', alignItems: '', justifyContent: 'start' }}>
        <h1 style={{ textAlign: 'center' }}>Terms & Conditions</h1>

        <h3 style={{ textAlign: 'center' }}>Last updated: July 9th, 2025</h3>
        <br />  
<p>These Terms and Conditions (“Terms”) govern your access to and use of ChessThread.com (“ChessThread,” “we,” “our,” or “us”), a social media platform dedicated to sharing and interacting with chess content. By accessing or using the platform, you agree to be bound by these Terms. If you do not agree, do not use the service.
</p>

<p>

        1. Acceptance of Terms<br />

By using ChessThread.com, you agree to comply with and be bound by these Terms. You may be required to affirm your consent during account creation. Continued use of the platform constitutes ongoing acceptance.<br /><br />


2. User Responsibilities<br />  

You may:<br />

- Create an account and publish chess-related content (e.g., games, comments, moves, discussions, etc.), for other users to view and engage with<br />
- View and interact with other users' content<br />
- Participate in public profiles, notifications, and discussion threads<br />
- Report abuse, inappropriate content, or violations<br /><br />

You must:<br />

- Use the platform only for chess-related purposes<br />
- Maintain a respectful, harassment-free environment<br />
- Follow topic relevance (chess only discussion)<br />
- Be kind<br /><br />

You may not:<br />

- Harass, threaten, spam, impersonate, or exploit others<br />
- Post unrelated, offensive, illegal, or malicious content<br />
- Use bots or attempt to scrape website data<br /><br />






        3. Account Registration and Security<br />

You must provide accurate information when creating an account. You are responsible for maintaining the security of your login credentials.<br /><br />

If you upgrade to a premium account in the future, payments will be handled via Stripe. We do not store your credit card information. Payment processing is handled securely through Stripe, and we only retain the necessary identifiers (e.g., customer ID) required for subscription verification.<br /><br />



4. Acceptable Use Policy<br />

You may only use ChessThread for respectful chess-related interaction. Any use intended to disrupt, exploit, or divert the platform from its purpose will result in suspension or removal.<br /><br />

Unacceptable behaviour includes but is not limited to:<br />

- Off-topic, sexualized, or political content<br />
- Hate speech, threats, or targeted abuse<br />
- Explicit language or imagery<br />
- Content that infringes intellectual property rights<br />
<br />

5. Community Moderation<br />

Users may report content or behaviour that violates any of these Terms. Reported content will be reviewed, but not all reports will result in removal. Final moderation authority rests with ChessThread.<br /><br />



        6. Termination of Accounts<br />

We reserve the right to suspend or delete any account, content, or activity that:<br />

- Violates these Terms<br />
- Undermines the chess-focused nature of the platform<br />
- Disrupts user experience or platform stability<br /><br />

We may take action without prior notice and at our sole discretion.<br /><br />

7. Disclaimers and Limitation of Liability<br />

ChessThread is provided “as is” with no warranties, express or implied. We do not guarantee uptime, availability, or the accuracy of user-submitted content.<br /><br />

We are not liable for:<br />

- Loss of data or content<br />
- User behavior or harmful content<br />
- Financial loss or indirect damages arising from use of the platform<br /><br />

Use is at your own risk.<br /><br />

8. Modifications to Terms<br />

We may revise these Terms at any time. Material changes will be communicated via the platform or email. Your continued use after such changes constitutes acceptance.<br /><br />

        9. Governing Law<br />

These Terms, and any additional terms, will be governed by and construed in accordance with the laws of the Province of Ontario, Canada, without regard to its conflict of laws principles.<br /><br />





        10. Dispute Resolution<br />

Before initiating legal action, parties shall attempt informal resolution. If unresolved, the dispute shall be submitted to the courts of Ontario unless otherwise agreed in writing.<br />
<br />

11. Indemnity<br />

You agree to indemnify, defend, and hold ChessThread harmless from any claims, damages, or liabilities arising from your content, your use of the service, or your violation of these Terms.<br />
<br />

        

        12. User-Generated Content Disclaimer<br />

ChessThread is not responsible for user-submitted content. We do not monitor all content and cannot guarantee its accuracy or appropriateness. Users post and view content at their own risk.<br />
Links to third-party sites are provided for convenience only. We are not responsible for their content or practices.
We may remove content or restrict users at our discretion.<br />
<br />

        13. Intellectual Property Rights<br />

You retain ownership of the content you create. By submitting content to the platform, you grant ChessThread a non-exclusive, royalty-free, perpetual license to:<br />

- Display, host, and distribute your content within the platform<br />
- Promote your content on external media or services<br />  <br />

You may request content removal at any time by contacting info@chessthread.com. We will comply where technically feasible and lawful.<br /><br />

    All site infrastructure, branding, design, and software are the property of ChessThread. Users may not copy, reverse-engineer, or commercially exploit the platform without written consent.<br /><br />


        14. Contact Information<br />

Questions or requests regarding these Terms should be sent to:<br />

    Email: info@chessthread.com<br /><br />

Use of ChessThread constitutes binding acceptance of these Terms in full. If you do not agree to these Terms, you must cease use of the platform immediately<br /><br />
          
        </p>
      </div>
    </div>
  );
};

export default Terms;